var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bean-source-page',{ref:"sourcePage",attrs:{"type":_vm.type,"columns":_vm.columns,"filter-columns":_vm.filterColumns,"form":_vm.form,"title":_vm.$t('model.user'),"form-columns":_vm.formColumns,"actions":_vm.actions,"resource":"users","index-exec-filter-router-type":"push","onFetchData":_vm.onFetchData}})
}
var staticRenderFns = []

export { render, staticRenderFns }